import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExcelMicrosoft365Logo = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	id: "a",
	"data-name": "\\u0421\\u043B\\u043E\\u0439 1",
	width: 486,
	height: 500,
	viewBox: "0 0 486 500",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsx("style", { children: "\n      .l {\n        fill: #fff;\n      }\n\n      .m {\n        fill: url(#d);\n      }\n\n      .n {\n        fill: url(#h);\n      }\n\n      .o {\n        fill: url(#j);\n      }\n\n      .p {\n        fill: url(#g);\n      }\n\n      .q {\n        fill: url(#k);\n      }\n\n      .q, .r {\n        fill-opacity: .3;\n      }\n\n      .s {\n        fill: url(#i);\n      }\n\n      .t {\n        fill: url(#f);\n      }\n\n      .u {\n        fill: url(#b);\n      }\n\n      .r {\n        fill: url(#e);\n      }\n\n      .v {\n        fill: url(#c);\n        fill-opacity: .7;\n      }\n    " }),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "b",
				"data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442",
				cx: -746.66,
				cy: 781.44,
				fx: -746.66,
				fy: 781.44,
				r: 13.89,
				gradientTransform: "translate(-2596.39 -38900.31) rotate(-133.54) scale(41.12 -31.9) skewX(-.01)",
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .06,
						stopColor: "#379539"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .42,
						stopColor: "#297c2d"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .7,
						stopColor: "#15561c"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "c",
				"data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 2",
				cx: -773.19,
				cy: 771.25,
				fx: -773.19,
				fy: 771.25,
				r: 13.89,
				gradientTransform: "translate(-2155.12 -15858.88) rotate(-135.96) scale(16.66 -12.89) skewX(-.01)",
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: 0,
					stopColor: "#073b10"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: .99,
					stopColor: "#084a13",
					stopOpacity: 0
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "d",
				"data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 3",
				x1: 69.43,
				y1: 210.33,
				x2: 260.84,
				y2: 210.33,
				gradientTransform: "translate(0 502) scale(1 -1)",
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: 0,
					stopColor: "#52d17c"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: .33,
					stopColor: "#4aa647"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "e",
				"data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 4",
				x1: 194.4,
				y1: 335.33,
				x2: 194.4,
				y2: 161.68,
				gradientTransform: "translate(0 502) scale(1 -1)",
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: 0,
					stopColor: "#29852f"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: .5,
					stopColor: "#4aa647",
					stopOpacity: 0
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "f",
				"data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 5",
				x1: 80.49,
				y1: 297.22,
				x2: 311.45,
				y2: 497.54,
				gradientTransform: "translate(0 502) scale(1 -1)",
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: 0,
					stopColor: "#66d052"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#85e972"
				})]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "g",
				"data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 6",
				cx: -824.11,
				cy: 810.99,
				fx: -824.11,
				fy: 810.99,
				r: 13.89,
				gradientTransform: "translate(-7120.4 -15378.69) rotate(-180) scale(9.02 -19.09)",
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: .29,
					stopColor: "#4eb43b"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#72cc61",
					stopOpacity: 0
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "h",
				"data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 7",
				x1: 182.11,
				y1: 377,
				x2: 69.43,
				y2: 377,
				gradientTransform: "translate(0 502) scale(1 -1)",
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: .18,
					stopColor: "#c0e075",
					stopOpacity: 0
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#d1eb95"
				})]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "i",
				"data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 8",
				cx: -769.14,
				cy: 808.9,
				fx: -769.14,
				fy: 808.9,
				r: 13.89,
				gradientTransform: "translate(-23523.37 3309.71) rotate(-141.02) scale(21.75 21.69) skewX(.01)",
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: .44,
					stopColor: "#79e96d"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#d0eb76"
				})]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "j",
				"data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 9",
				cx: -675.64,
				cy: 793.28,
				fx: -675.64,
				fy: 793.28,
				r: 13.89,
				gradientTransform: "translate(-25315.85 47178.18) rotate(45.01) scale(22.62 -64.41) skewX(-.04)",
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: 0,
					stopColor: "#20a85e"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: .94,
					stopColor: "#09442a"
				})]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "k",
				"data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 10",
				cx: -657.62,
				cy: 853.99,
				fx: -657.62,
				fy: 853.99,
				r: 13.89,
				gradientTransform: "translate(-10902.85 7734.8) rotate(90) scale(11.2 -12.9)",
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: .58,
					stopColor: "#33a662",
					stopOpacity: 0
				}), /* @__PURE__ */ _jsx("stop", {
					offset: .97,
					stopColor: "#98f0b0"
				})]
			})
		] }),
		/* @__PURE__ */ _jsx("path", {
			className: "u",
			d: "M69.43,159.72c0-34.52,27.98-62.5,62.49-62.5h354.09v361.11c0,23.01-18.65,41.67-41.66,41.67H152.74c-46.01,0-83.31-37.31-83.31-83.33V159.72Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "v",
			d: "M69.43,159.72c0-34.52,27.98-62.5,62.49-62.5h354.09v361.11c0,23.01-18.65,41.67-41.66,41.67H152.74c-46.01,0-83.31-37.31-83.31-83.33V159.72Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "m",
			d: "M69.43,229.17c0-34.52,27.98-62.5,62.49-62.5h187.46c-23.01,0-41.66,18.66-41.66,41.67v83.33c0,23.01-18.65,41.67-41.66,41.67h-83.31c-46.01,0-83.31,37.31-83.31,83.33v-187.5Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "r",
			d: "M69.43,229.17c0-34.52,27.98-62.5,62.49-62.5h187.46c-23.01,0-41.66,18.66-41.66,41.67v83.33c0,23.01-18.65,41.67-41.66,41.67h-83.31c-46.01,0-83.31,37.31-83.31,83.33v-187.5Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "t",
			d: "M69.43,83.33C69.43,37.31,106.73,0,152.74,0h166.63v166.67h-166.63c-46.01,0-83.31,37.31-83.31,83.33V83.33Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "p",
			d: "M69.43,83.33C69.43,37.31,106.73,0,152.74,0h166.63v166.67h-166.63c-46.01,0-83.31,37.31-83.31,83.33V83.33Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "n",
			d: "M69.43,83.33C69.43,37.31,106.73,0,152.74,0h166.63v166.67h-166.63c-46.01,0-83.31,37.31-83.31,83.33V83.33Z"
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "s",
			x: 277.71,
			width: 208.29,
			height: 166.67,
			rx: 41.66,
			ry: 41.66
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "o",
			y: 236.11,
			width: 222.17,
			height: 222.22,
			rx: 45.13,
			ry: 45.13
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "q",
			y: 236.11,
			width: 222.17,
			height: 222.22,
			rx: 45.13,
			ry: 45.13
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "l",
			d: "M169.48,410.71h-34.25l-21.5-40.47c-.77-1.42-1.36-2.54-1.77-3.37-.35-.88-.74-1.89-1.15-3.01h-.35c-.53,1.42-1.03,2.57-1.5,3.45-.47.89-1.03,1.98-1.68,3.28l-22.3,40.11h-32.3l38.76-63.58-36.1-63.4h33.8l19.11,36.13c.77,1.48,1.42,2.78,1.95,3.9.59,1.06,1.18,2.33,1.77,3.81h.35c.82-1.71,1.47-3.07,1.95-4.07.53-1,1.24-2.33,2.12-3.98l19.82-35.77h32.21l-36.63,62.43,37.7,64.55Z"
		})
	]
});
export default SvgExcelMicrosoft365Logo;
